// Frames API — mirrors /app/mobile/src/lib/frames-api.ts
import { apiFetch, BACKEND_URL } from './api';

export { BACKEND_URL };

export const PRESET_CROPS = {
  '16:9': { ratio: '16:9', x: 0.0, y: 0.15, w: 1.0, h: 0.5625 },
  '4:3':  { ratio: '4:3',  x: 0.0, y: 0.05, w: 1.0, h: 0.75 },
  '1:1':  { ratio: '1:1',  x: 0.1, y: 0.05, w: 0.8, h: 0.9 },
  '9:16': { ratio: '9:16', x: 0.28, y: 0.0, w: 0.44, h: 1.0 },
  freeform: { ratio: 'freeform', x: 0.05, y: 0.05, w: 0.9, h: 0.9 },
};

export const RATIOS = ['16:9', '4:3', '1:1', '9:16', 'freeform'];

export const listCollections = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/frame-collections`);

export const createCollection = (eventId, name, description = '') =>
  apiFetch(`/api/v1/events/${eventId}/frame-collections`, { method: 'POST', body: JSON.stringify({ name, description }) });

export const addItem = (eventId, colId, submissionId, crop) =>
  apiFetch(`/api/v1/events/${eventId}/frame-collections/${colId}/items`, { method: 'POST', body: JSON.stringify({ submission_id: submissionId, crop }) });

export const patchItemCrop = (eventId, colId, subId, crop) =>
  apiFetch(`/api/v1/events/${eventId}/frame-collections/${colId}/items/${subId}`, { method: 'PATCH', body: JSON.stringify(crop) });

export const removeItem = (eventId, colId, subId) =>
  apiFetch(`/api/v1/events/${eventId}/frame-collections/${colId}/items/${subId}`, { method: 'DELETE' });

export const requestExport = (eventId, colId) =>
  apiFetch(`/api/v1/events/${eventId}/frame-collections/${colId}/export`, { method: 'POST' });

export const getExportJob = (jobId) =>
  apiFetch(`/api/v1/frame-export-jobs/${jobId}`);
